import { Colors, FlexBox,  FInter } from '@brg/ui';
import styled, { css } from "styled-components";
import { LayoutConst } from 'core/modules';
import EditIcon24 from 'shared/icons/EditIcon24';
import DeleteIcon16 from 'shared/icons/DeleteIcon16';

interface CustomIconProps {
    iconSize?: string;
  }

export const ScheduleModalBody = styled(FlexBox)`
  
  margin-bottom: 15vh;

  @media (max-width:${LayoutConst.screen.m}px) {
    margin-top: 64px;
    margin-bottom: 65px;
  }
  
  @media (max-width:${LayoutConst.screen.s - 1}px) {
    overflow: auto;
    align-items: flex-start;
  }
`;

export const ScheduleModalWrapper = styled(FlexBox)`
    width: 1152px;
    justify-content: flex-start !important;
    flex-direction: column;
    @media (max-width:${LayoutConst.screen.l_12}px) {
        width: 940px;
    }
    @media (max-width: 992px) {
        margin: 0 16px 100px;
        width: 100%;
    }
  @media (max-width:${LayoutConst.screen.s - 1}px) {
    margin: 0px 10px 0px;
  }
`;

export const ScheduleModalTitle = styled.h2`
    color:  #151514;
    font-family: Inter;
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: 70px; 
    letter-spacing: -0.02em;
    margin-bottom: 40px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
    margin-bottom: 24px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const ScheduleModalContent = styled.div`
    width:100%;
    height: 600px;
    display:flex;
    justify-content: flex-start;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: column;
    height: auto;
  }
`;

export const ScheduleModalLessonsContent = styled(FlexBox)`
  width: 100%;
  flex-direction: row;

  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: row;
    height: 440px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column-reverse;
    height: auto;
  }
`;

export const ScheduleModalForm = styled.div`
    min-width: 428px;
    height: 100%;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 428px;
    min-width: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    min-width: auto;
    width: 100%;
  }
`;

export const InputSectionFlexBox = styled(FlexBox)`
    display: flex;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
    flex-direction: row;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const ScheduleButtonWrapper = styled(FlexBox)`

  row-gap: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
    flex-direction: row;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    row-gap: 16px;
    flex-direction: column;
    margin-top: 16px;
    margin-bottom: 24px;
  }
`;

export const ScheduleModalPlanner = styled.div`
    padding: 16px 0 16px 16px;
    background-color: ${Colors.galBlack5};
    display: flex;
    flex-direction: column;

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 24px 10px;
  }
`;

export const ScheduleModalNotes = styled.div`
    height: 100%;
    overflow-y: scroll;
    height: fit-content;
    display: grid;
    gap: 32px;

    ::-webkit-scrollbar {
        width: 4px;
      }
    
      ::-webkit-scrollbar-thumb {
        background-color: ${Colors.galBlack27}; 
        border-radius: 2px;
        height: 92px;
      }
    
      ::-webkit-scrollbar-track {
        background-color: ${Colors.galBlack5};
      }
`;

export const  ScheduleModalСalendar = styled.div`
    height: 100%;
    background: ${Colors.galBlack5};
    padding: 16px 16px 16px 24px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 100%;
    padding: 16px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 10px;
  }
`;

export const ScheduleModalInput = styled(FlexBox)`
  flex-direction: column;
  margin-bottom: 16px;
  height: 56px;
`;

export const ScheduleEditPageGridLabel = styled(FInter.SmallTextFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: 100%;
  min-width: 127px;
  align-items: center;
  margin-bottom: 8px;
  position: relative;


  ${({ fixedHeight }) => fixedHeight ? css`
    height: 32px;
    max-height: 32px;
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 3px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }
    .brg-input__menu {
    background-color: ${({theme}) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({theme}) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    min-width: 115px;
    width: 100%;

    ${({ fixedHeight }) => fixedHeight ? css`
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};
  }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 16px;
    width: 76px;
    min-width: 76px;
    white-space: nowrap !important;

    ${({ isTeamEdit, isTable }) => isTeamEdit ? css`
      min-width: 170px;
      font-size: ${isTable ? '13px' : '17px'};
      line-height: ${isTable ? '16px' : '22px'};
  ` : null};
  }

  @media(max-width: 834px) {
    white-space: nowrap !important;

    ${({ isTeamEdit }) => isTeamEdit ? css`
      min-width: 170px;
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isTable, isCheckbox }) => isTeamEdit ? css`
      margin-bottom: ${isCheckbox ? 0 : '8px'};
      font-size: ${isTable ? '13px' : '15px'};
      line-height: ${isTable ? '16px' : '20px'};
      white-space: nowrap;
      width: 100%;
      min-width: none;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS && css`
    min-width: auto;
    width: auto;
  `};
}
`;

export const LMSScheduleEditPageGridInput = styled(ScheduleEditPageGridLabel)`
  
  width: 100%;
  
  .brg-input__control {
    background: ${Colors.galBlack5};
    outline: none!important;
    cursor: pointer;
    border: none;
    height: 32px!important;
    margin-bottom: 0;
    min-height: 32px!important;
    color: ${Colors.zel};
    align-content: center;
  
    .brg-input__placeholder{
        color: ${Colors.galBlack27};
        
      }

      .brg-input__placeholder:hover {
        color: ${Colors.galBlack47};
      }

    .brg-input__single-value {
    font-size: 13px;
    line-height: 16px;
    color: black;
    }

    :hover .brg-input__placeholder{
      color: ${Colors.galBlack47};
    }

  }
  
  input {
    background: ${Colors.galBlack5}!important;
    ::placeholder{
      color: ${Colors.galBlack27};
    }
  }

  input:hover {
    color:${Colors.galBlack47};
    ::placeholder {
      color: ${Colors.galBlack47};
    }  
  }

  .text-input{
    height: 32px!important;
    border:none!important;
    color: ${Colors.zel};

    :hover{
      color: ${Colors.galBlack47};
    }
  }

  .brg-input__indicator {
    svg {
        path {
            fill: ${Colors.zel};
          }
      }
  }

  .brg-input__menu{
    background: ${Colors.defaultGrey6};

    * {
    color: ${Colors.galBlack100};
     }

     svg {
      path {
        fill:${Colors.galBlack100};
      }
     }
  }
`;

export const ScheduleModalAddButton =  styled.button`
    width: 100%;
    height: 46px;
    border-radius: 3px;
    padding: 8px 24px;
    background-color: ${({disabled}) => disabled ? Colors.galBlack47 : Colors.galBlack100};
    color: ${({disabled}) => disabled ? Colors.geoWhite73 : Colors.geoWhite100};
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    border:none;
    cursor:pointer;

    :hover{
      background-color: ${({disabled}) => disabled ? Colors.galBlack47 : '#1F1F1F'}!important;
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px;
    width: calc(50% - 8px);
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 46px;
    width: 100%;
  }
`;
export const ScheduleModalCancelButton =  styled(ScheduleModalAddButton)`
    background-color: transparent!important;
    color: ${Colors.galBlack100};
    border: 1px ${Colors.galBlack100} solid;

  :hover{
    background-color: transparent!important;
  }
`;

export const ScheduleModalTimeInput = styled(FlexBox)`
    width: 100%;
    flex-direction: column;
// input[type="time"]::-webkit-calendar-picker-indicator {
//   color-scheme: dark;
// }
    .time-input {
    padding-left: 16px;
    padding-right: 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack47};
    -webkit-transition: border 0.2s;
    transition: border 0.2s;
    padding-top: 16px;
    padding-bottom: 13px;
    height: 32px!important;
    box-sizing: border-box;
    outline: none!important;
    width: 100%;
    border-radius: 3px;
    border: none;
    background: ${Colors.galBlack5};
      
    @media (max-width: ${LayoutConst.screen.m}px) {
     height: 32px !important;
    }
}

.time-input:disabled {
  color: ${Colors.galBlack47};
}

input[type="time"]::-webkit-calendar-picker-indicator {
    display: none;
}
`;

export const ScheduleModalNote = styled.div`
    display: flex;
    width: 100%;
`;

export const DateNote = styled.div<{isFirst?: boolean}>`
    min-width: 78px;
    height: 70px;
    background: ${({ isFirst }) => isFirst ? Colors.gal : 'transparent'};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 0px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    display: ${({ isFirst }) => isFirst ? 'flex' : 'none'};
    margin-top: ${({ isFirst }) => isFirst ? '16px' : '0'};
    flex-direction: row;
    padding: 8px;
    height: auto;
    border-radius: 3px;
  }
`;

const DateTextStyle = styled.p`
    margin:0;
    padding:0;
    font-family: Inter;
    font-style: normal;
`;

export const DateNoteWeekday = styled(DateTextStyle)`
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: -0.26px;
    text-decoration: uppercase;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    font-size: 22px;
    line-height: 22px;
  }
`;

export const DateNoteDay = styled(DateTextStyle)`
    font-size: 22px;
    font-weight: 700;
    line-height: 22px; 
    letter-spacing: -0.44px;
`;

export const DateNoteMonth= styled(DateNoteWeekday)`
    text-decoration: normal;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-left: 8px;
    width: auto;
  }
`;

export const DescriptionBlockNote = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 396px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    gap: 16px;
    min-width: auto;
  }
`;

export const DescriptionNoteText = styled.p`
    color: ${Colors.galBlack47};
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin: 0;
`;

export const DescriptionNoteTime = styled(DescriptionNoteText)`
    margin-bottom: 4px;
`;

export const DescriptionNoteLink = styled(DescriptionNoteText)`
    text-decoration: underline;
    margin-bottom: 8px;
`;

export const DescriptionNoteTheme = styled(DescriptionNoteText)`
    color: ${Colors.zel}!important;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.3px;
`;

export const DescriptionNoteGroupButtons = styled.div`
    display:none;
`;

const DescriptionNoteButton = styled.button`
    width: 24px;
    height: 20px;
    background: #181A1C80;
    border: none;
    padding: 2px 4px;
    box-sizing: border-box;
    border-radius: 4px;
    cursor:pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        path {
            fill: #FFFFFF;
        }
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    background: ${Colors.geoWhite100};

    svg {
      path {
        fill: ${Colors.galBlack100};
      }
    }
  }
`;

export const DescriptionNoteEditButton = styled(DescriptionNoteButton)`
margin-bottom: 4px;
`;

export const DescriptionNoteDeleteButton = styled(DescriptionNoteButton)``;

export const DescriptionNote = styled.div<{active?: boolean}>`
    width: 100%;
    color: ${({active}) => active ? '#CDCDCD' : Colors.galBlack73};
    // display: flex;
    // justify-content: space-between;
    cursor:pointer;
    display: flex;
    align-items: center;
    gap: 16px;
    &:hover {
     //background-color: #CDCDCD;
     ${DescriptionNoteGroupButtons} {
        //display:flex;
        //flex-direction: column;
    }

    ${DescriptionNoteText} {
      //color: #70706F;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const DescriptionNoteDetails = styled.div<{active?: boolean}>`
  background: ${({active}) => active ? '#CDCDCD' : 'transparent'};
  ${DescriptionNoteText} {
    color: ${({active}) => active ? '#70706F' : '#909090'};
  }
  &:hover {
    background-color: #CDCDCD;
    ${DescriptionNoteText} {
      color: #70706F;
    }
    ${DescriptionNoteGroupButtons} {
      display:flex;
      flex-direction: column;
    }
  }
  margin: 0 16px 0 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 0px;
    margin: 0 16px 0 0;
    ${DescriptionNoteGroupButtons} {
      display:flex;
      flex-direction: column;
    }

    background: transparent;
    ${DescriptionNoteText} {
      color: #909090;
    }
    &:hover {
      background-color: transparent;
      ${DescriptionNoteText} {
        color: #909090;
      }
    }
  }
`
  
export const CustomEditIcon = styled(EditIcon24)<CustomIconProps>`
    width: ${(props) => props.iconSize || '24px'};
    height: ${(props) => props.iconSize || '24px'};
  `;

  export const CustomDeleteIcon = styled(DeleteIcon16)<CustomIconProps>`
    width: ${(props) => props.iconSize || '16px'};
    height: ${(props) => props.iconSize || '16px'};
  `;
import { Colors, FlexBox,  FInter } from '@brg/ui';
import styled, { css } from "styled-components";
import { LayoutConst } from 'core/modules';
import EditIcon24 from 'shared/icons/EditIcon24';
import DeleteIcon16 from 'shared/icons/DeleteIcon16';

interface CustomIconProps {
    iconSize?: string;
  }

export const ScheduleModalBody = styled(FlexBox)`
  
  margin-bottom: 15vh;

  @media (max-width:${LayoutConst.screen.m}px) {
    margin-top: 64px;
    margin-bottom: 65px;
  }
  
  @media (max-width:${LayoutConst.screen.s - 1}px) {
    overflow: auto;
    align-items: flex-start;
  }
`;

export const ScheduleModalWrapper = styled(FlexBox)`
    width: 1152px;
    justify-content: flex-start !important;
    flex-direction: column;
    @media (max-width:${LayoutConst.screen.l_12}px) {
        width: 940px;
    }
    @media (max-width: 992px) {
        margin: 0 16px 100px;
        width: 100%;
    }
  @media (max-width:${LayoutConst.screen.s - 1}px) {
    margin: 0px 10px 0px;
  }
`;

export const ScheduleModalTitle = styled.h2`
    color:  #151514;
    font-family: Inter;
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: 70px; 
    letter-spacing: -0.02em;
    margin-bottom: 40px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
    margin-bottom: 24px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const ScheduleModalContent = styled.div`
    width:100%;
    height: 600px;
    display:flex;
    justify-content: flex-start;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: column;
    height: auto;
  }
`;

export const ScheduleModalLessonsContent = styled(FlexBox)`
  width: 100%;
  flex-direction: row;

  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: row;
    height: 440px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column-reverse;
    height: auto;
  }
`;

export const ScheduleModalForm = styled.div`
    min-width: 428px;
    height: 100%;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 428px;
    min-width: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    min-width: auto;
    width: 100%;
  }
`;

export const InputSectionFlexBox = styled(FlexBox)`
    display: flex;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
    flex-direction: row;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const ScheduleButtonWrapper = styled(FlexBox)`

  row-gap: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 16px;
    flex-direction: row;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    row-gap: 16px;
    flex-direction: column;
    margin-top: 16px;
    margin-bottom: 24px;
  }
`;

export const ScheduleModalPlanner = styled.div`
    padding: 16px 0 16px 16px;
    background-color: ${Colors.galBlack5};
    display: flex;
    flex-direction: column;

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 24px 10px;
  }
`;

export const ScheduleModalNotes = styled.div`
    height: 100%;
    overflow-y: scroll;
    height: fit-content;
    display: grid;
    gap: 32px;

    ::-webkit-scrollbar {
        width: 4px;
      }
    
      ::-webkit-scrollbar-thumb {
        background-color: ${Colors.galBlack27}; 
        border-radius: 2px;
        height: 92px;
      }
    
      ::-webkit-scrollbar-track {
        background-color: ${Colors.galBlack5};
      }
`;

export const  ScheduleModalСalendar = styled.div`
    height: 100%;
    background: ${Colors.galBlack5};
    padding: 16px 16px 16px 24px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 100%;
    padding: 16px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 10px;
  }
`;

export const ScheduleModalInput = styled(FlexBox)`
  flex-direction: column;
  margin-bottom: 16px;
  height: 56px;
`;

export const ScheduleEditPageGridLabel = styled(FInter.SmallTextFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: 100%;
  min-width: 127px;
  align-items: center;
  margin-bottom: 8px;
  position: relative;


  ${({ fixedHeight }) => fixedHeight ? css`
    height: 32px;
    max-height: 32px;
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 3px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }
    .brg-input__menu {
    background-color: ${({theme}) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({theme}) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    min-width: 115px;
    width: 100%;

    ${({ fixedHeight }) => fixedHeight ? css`
    padding-top: 0;
  ` : null};

  ${({ nowrap }) => nowrap && css`
    white-space: nowrap;
  `};
  }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 16px;
    width: 76px;
    min-width: 76px;
    white-space: nowrap !important;

    ${({ isTeamEdit, isTable }) => isTeamEdit ? css`
      min-width: 170px;
      font-size: ${isTable ? '13px' : '17px'};
      line-height: ${isTable ? '16px' : '22px'};
  ` : null};
  }

  @media(max-width: 834px) {
    white-space: nowrap !important;

    ${({ isTeamEdit }) => isTeamEdit ? css`
      min-width: 170px;
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isTable, isCheckbox }) => isTeamEdit ? css`
      margin-bottom: ${isCheckbox ? 0 : '8px'};
      font-size: ${isTable ? '13px' : '15px'};
      line-height: ${isTable ? '16px' : '20px'};
      white-space: nowrap;
      width: 100%;
      min-width: none;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS && css`
    min-width: auto;
    width: auto;
  `};
}
`;

export const LMSScheduleEditPageGridInput = styled(ScheduleEditPageGridLabel)`
  
  width: 100%;
  
  .brg-input__control {
    background: ${Colors.galBlack5};
    outline: none!important;
    cursor: pointer;
    border: none;
    height: 32px!important;
    margin-bottom: 0;
    min-height: 32px!important;
    color: ${Colors.zel};
    align-content: center;
  
    .brg-input__placeholder{
        color: ${Colors.galBlack27};
        
      }

      .brg-input__placeholder:hover {
        color: ${Colors.galBlack47};
      }

    .brg-input__single-value {
    font-size: 13px;
    line-height: 16px;
    color: black;
    }

    :hover .brg-input__placeholder{
      color: ${Colors.galBlack47};
    }

  }
  
  input {
    background: ${Colors.galBlack5}!important;
    ::placeholder{
      color: ${Colors.galBlack27};
    }
  }

  input:hover {
    color:${Colors.galBlack47};
    ::placeholder {
      color: ${Colors.galBlack47};
    }  
  }

  .text-input{
    height: 32px!important;
    border:none!important;
    color: ${Colors.zel};

    :hover{
      color: ${Colors.galBlack47};
    }
  }

  .brg-input__indicator {
    svg {
        path {
            fill: ${Colors.zel};
          }
      }
  }

  .brg-input__menu{
    background: ${Colors.defaultGrey6};

    * {
    color: ${Colors.galBlack100};
     }

     svg {
      path {
        fill:${Colors.galBlack100};
      }
     }
  }
`;

export const ScheduleModalAddButton =  styled.button`
    width: 100%;
    height: 46px;
    border-radius: 3px;
    padding: 8px 24px;
    background-color: ${({disabled}) => disabled ? Colors.galBlack47 : Colors.galBlack100};
    color: ${({disabled}) => disabled ? Colors.geoWhite73 : Colors.geoWhite100};
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    border:none;
    cursor:pointer;

    :hover{
      background-color: ${({disabled}) => disabled ? Colors.galBlack47 : '#1F1F1F'}!important;
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: 36px;
    width: calc(50% - 8px);
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 46px;
    width: 100%;
  }
`;
export const ScheduleModalCancelButton =  styled(ScheduleModalAddButton)`
    background-color: transparent!important;
    color: ${Colors.galBlack100};
    border: 1px ${Colors.galBlack100} solid;

  :hover{
    background-color: transparent!important;
  }
`;

export const ScheduleModalTimeInput = styled(FlexBox)`
    width: 100%;
    flex-direction: column;
// input[type="time"]::-webkit-calendar-picker-indicator {
//   color-scheme: dark;
// }
    .time-input {
    padding-left: 16px;
    padding-right: 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack47};
    -webkit-transition: border 0.2s;
    transition: border 0.2s;
    padding-top: 16px;
    padding-bottom: 13px;
    height: 32px!important;
    box-sizing: border-box;
    outline: none!important;
    width: 100%;
    border-radius: 3px;
    border: none;
    background: ${Colors.galBlack5};
      
    @media (max-width: ${LayoutConst.screen.m}px) {
     height: 32px !important;
    }
}

.time-input:disabled {
  color: ${Colors.galBlack47};
}

input[type="time"]::-webkit-calendar-picker-indicator {
    display: none;
}
`;

export const ScheduleModalNote = styled.div`
    display: flex;
    width: 100%;
`;

export const DateNote = styled.div<{isFirst?: boolean}>`
    min-width: 78px;
    height: 70px;
    background: ${({ isFirst }) => isFirst ? Colors.gal : 'transparent'};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 0px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    display: ${({ isFirst }) => isFirst ? 'flex' : 'none'};
    margin-top: ${({ isFirst }) => isFirst ? '16px' : '0'};
    flex-direction: row;
    padding: 8px;
    height: auto;
    border-radius: 3px;
  }
`;

const DateTextStyle = styled.p`
    margin:0;
    padding:0;
    font-family: Inter;
    font-style: normal;
`;

export const DateNoteWeekday = styled(DateTextStyle)`
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: -0.26px;
    text-decoration: uppercase;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    font-size: 22px;
    line-height: 22px;
  }
`;

export const DateNoteDay = styled(DateTextStyle)`
    font-size: 22px;
    font-weight: 700;
    line-height: 22px; 
    letter-spacing: -0.44px;
`;

export const DateNoteMonth= styled(DateNoteWeekday)`
    text-decoration: normal;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-left: 8px;
    width: auto;
  }
`;

export const DescriptionBlockNote = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 396px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    gap: 16px;
    min-width: auto;
  }
`;

export const DescriptionNoteText = styled.p`
    color: ${Colors.galBlack47};
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin: 0;
`;

export const DescriptionNoteTime = styled(DescriptionNoteText)`
    margin-bottom: 4px;
`;

export const DescriptionNoteLink = styled(DescriptionNoteText)`
    text-decoration: underline;
    margin-bottom: 8px;
`;

export const DescriptionNoteTheme = styled(DescriptionNoteText)`
    color: ${Colors.zel}!important;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.3px;
`;

export const DescriptionNoteGroupButtons = styled.div`
    display:none;
`;

const DescriptionNoteButton = styled.button`
    width: 24px;
    height: 20px;
    background: #181A1C80;
    border: none;
    padding: 2px 4px;
    box-sizing: border-box;
    border-radius: 4px;
    cursor:pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        path {
            fill: #FFFFFF;
        }
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    background: ${Colors.geoWhite100};

    svg {
      path {
        fill: ${Colors.galBlack100};
      }
    }
  }
`;

export const DescriptionNoteEditButton = styled(DescriptionNoteButton)`
margin-bottom: 4px;
`;

export const DescriptionNoteDeleteButton = styled(DescriptionNoteButton)``;

export const DescriptionNote = styled.div<{active?: boolean}>`
    width: 100%;
    color: ${({active}) => active ? '#CDCDCD' : Colors.galBlack73};
    // display: flex;
    // justify-content: space-between;
    cursor:pointer;
    display: flex;
    align-items: center;
    gap: 16px;
    &:hover {
     //background-color: #CDCDCD;
     ${DescriptionNoteGroupButtons} {
        //display:flex;
        //flex-direction: column;
    }

    ${DescriptionNoteText} {
      //color: #70706F;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const DescriptionNoteDetails = styled.div<{active?: boolean}>`
  background: ${({active}) => active ? '#CDCDCD' : 'transparent'};
  ${DescriptionNoteText} {
    color: ${({active}) => active ? '#70706F' : '#909090'};
  }
  &:hover {
    background-color: #CDCDCD;
    ${DescriptionNoteText} {
      color: #70706F;
    }
    ${DescriptionNoteGroupButtons} {
      display:flex;
      flex-direction: column;
    }
  }
  margin: 0 16px 0 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 0px;
    margin: 0 16px 0 0;
    ${DescriptionNoteGroupButtons} {
      display:flex;
      flex-direction: column;
    }

    background: transparent;
    ${DescriptionNoteText} {
      color: #909090;
    }
    &:hover {
      background-color: transparent;
      ${DescriptionNoteText} {
        color: #909090;
      }
    }
  }
`
  
export const CustomEditIcon = styled(EditIcon24)<CustomIconProps>`
    width: ${(props) => props.iconSize || '24px'};
    height: ${(props) => props.iconSize || '24px'};
  `;

  export const CustomDeleteIcon = styled(DeleteIcon16)<CustomIconProps>`
    width: ${(props) => props.iconSize || '16px'};
    height: ${(props) => props.iconSize || '16px'};
  `;
